import {Skeleton} from "primereact/skeleton"
import {useState} from "react"
import useSWR from "swr"

import {OrientationReadinessChart} from "../orientation/OrientationReadinessChart"
import {OrientationReadinessColumn} from "../orientation/OrientationReadinessColumn"
import {OrientationWeekDetails} from "../orientation/OrientationWeekDetails"
import {fetcherGet, getLocaleDate, getShiftedWeeks} from "../../utilities/general"

export const PreceptorOrientationDetails = ({orientationId}) => {
    const {data: orientee, isLoading} = useSWR(`/orientation-details?orientation-id=${orientationId}`, fetcherGet, {
        fallbackData: {},
    })
    const [visibleWeeks, setVisibleWeeks] = useState(3)

    const weeks = orientee.weeks ?? {}

    if (isLoading) {
        return <Skeleton width="100%" height="8rem" />
    }
    return (
        <>
            <div className="row row-cols-1 row-cols-lg-2 g-4 m-4">
                <div className="col">
                    <div className="d-flex flex-wrap fw-semibold fs-6 mb-md-0 mb-4 pe-2 gap-2">
                        <span className="d-flex align-items-center me-5 mb-2">
                            <i className={"fas text-primary fs-6 me-2 fa-hospital"}></i>
                            {orientee.unit_name ? orientee.unit_name : "No Info"}
                        </span>
                        <span className="d-flex align-items-center me-5 mb-2">
                            <i className={"fas text-primary fs-6 me-2 fa-user-nurse"}></i>
                            {orientee.position_name ? orientee.position_name : "No Info"}
                        </span>
                        <span className="d-flex align-items-center me-5 mb-2">
                            <i className={"fas text-primary fs-6 me-2 fa-clock-rotate-left"}></i>
                            Prior Exp: {orientee.experience_level_name ? orientee.experience_level_name : "No Info"}
                        </span>
                        <span className="d-flex align-items-center me-5 mb-2">
                            <i className={"fas text-primary fs-6 me-2 fa-graduation-cap"}></i>
                            {orientee.nursing_program_completed
                                ? `${orientee.nursing_program_completed} ${getLocaleDate(orientee.nurse_graduate_board_date)}`
                                : "No Info"}
                        </span>
                        <span className="d-flex align-items-center me-5 mb-2">
                            <i className={"fas text-primary fs-6 me-2 fa-flag"}></i>
                            Hired: {orientee.hire_date ? getLocaleDate(orientee.hire_date) : "No Info"}
                        </span>
                        <span className="d-flex align-items-center me-5 mb-2">
                            <i className={"fas text-primary fs-6 me-2 fa-flag"}></i>
                            Started: {orientee.start_date ? getLocaleDate(orientee.start_date) : "No Info"}
                        </span>

                        <span className="d-flex align-items-center me-5 mb-2">
                            <i className="fas text-primary fs-6 me-2 fa-calendar-xmark"></i>
                            Expected End Date: {orientee.expected_end_date
                                ? getLocaleDate(orientee.expected_end_date)
                                : "No Info"}
                        </span>
                        <span className="d-flex align-items-center me-5 mb-2">
                            <i className="fas text-primary fs-6 me-2 fa-calendar-xmark"></i>
                            Length: {orientee.standard_orientation_length_weeks
                                ? `${orientee.standard_orientation_length_weeks} weeks`
                                : "No Info"}
                            {orientee.educator_shifted_weeks ? (
                                <span className="ms-2">{getShiftedWeeks(orientee)}</span>
                            ) : null}
                        </span>
                    </div>
                </div>
                <OrientationReadinessColumn percentOSRScore={orientee.current_percent_max_osr_score} />
            </div>
            <div className="card-header px-0 m-4">
                <h3 className="card-title fs-5 fw-bold">Weekly Progress</h3>
            </div>
            <div className="card-body pt-5 h-350px">
                <OrientationReadinessChart orientee={orientee} />
            </div>
            <div className="d-flex flex-column gap-2 mb-4">
                {Object.keys(weeks)
                    .sort((a, b) => parseInt(b) - parseInt(a))
                    .slice(0, visibleWeeks)
                    .map((week) => {
                        const weekData = weeks[week]
                        return <OrientationWeekDetails key={week} week={week} weekData={weekData} orientation={orientee} />
                    })}
            </div>
            {visibleWeeks < Object.keys(weeks).length && (
                <div className="d-flex flex-column mt-4">
                    <button className="btn btn-light-primary" onClick={() => setVisibleWeeks(visibleWeeks + 3)}>
                        Load More Weeks
                    </button>
                </div>
            )}
        </>
    )
}
